import Modal from "@common/controls/Modal/component";
import { IconType } from "@common/declarations";
import { type Boundaries } from "@common/hocs/draggable/lib";
import { useI18n } from "@common/hooks/i18n";
import { type Ai } from "@common/modules/ai/types";
import classNames from "classnames";
import React from "react";
import Chat from "./Chat";
import History from "./History";

const BOUNDARIES: Boundaries = {
  bottom: 16,
  left: 16,
  right: 16,
  top: 16
};
type PropsInner = {
  agentName: string;
  chats?: Ai.Chat.View.Chat[];
  className?: string;
  data: Ai.ChatMessage.View.ChatMessage[];
  isChatDisabled: boolean;
  isLoading: boolean;
  isVisible: boolean;
  onClose: () => void;
  onSelectChatHistory?: (chatId: string) => void;
  sendMessage: (input: string) => Promise<string | null>;
  setResponseMark?: (id: string, isPositive: boolean) => Promise<void>;
  title: string;
  welcomeMessage: string;
};
export default (props: PropsInner) => {
  const i18n = useI18n();

  const [isHistoryVisible, setIsHistoryVisible] = React.useState<boolean>(false);

  const onSelectChatHistory = React.useCallback(
    (id: string) => {
      props.onSelectChatHistory && props.onSelectChatHistory(id);
      setIsHistoryVisible(false);
    },
    [props.onSelectChatHistory]
  );

  return (
    <Modal
      action={
        !!props.chats?.length && !!props.onSelectChatHistory && !isHistoryVisible
          ? { icon: IconType.History, onClick: () => setIsHistoryVisible(true) }
          : undefined
      }
      boundaries={BOUNDARIES}
      className={classNames("ai_chat_modal", props.className)}
      defaultIsEnlarged={false}
      defaultIsPinned
      enlagedWidth={600}
      hasBackdrop={false}
      height={560}
      isDraggable
      isLoading={props.isLoading}
      isVisible={props.isVisible}
      maxHeight={"100vh"}
      onBack={isHistoryVisible ? () => setIsHistoryVisible(false) : undefined}
      onClose={props.onClose}
      storageId="AI_CHAT_MODAL"
      width={400}
    >
      <Modal.Header title={isHistoryVisible ? i18n.chatHistory : props.title} />

      <Modal.Body>
        <div className="content">
          {isHistoryVisible ? (
            <History onSelect={onSelectChatHistory} chats={props.chats!} />
          ) : (
            <Chat
              agentName={props.agentName}
              chats={props.chats}
              isDisabled={props.isChatDisabled}
              messages={props.data}
              onSendMessage={props.sendMessage}
              welcomeMessage={props.welcomeMessage}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
